import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from "@angular/core";
import {FUIModalsService} from "@fedeltapointofsale/ui";
import {ProductCountDownData} from "../product-count-down.data";

@Component({
    selector: "wbo-app-item-availability-edit-modal",
    templateUrl: "app-item-availability-edit-modal.component.html",
    styleUrls: ["./app-item-availability-edit-modal.component.scss"],
})
export class AppItemAvailabilityEditModalComponent {
    @Output() onClose: EventEmitter<boolean> = new EventEmitter();

    sellableId: number;
    sellableName: string;
    outletGroupId: number;
    countdowns: { [sellableId: string]: ProductCountDownData } = {};

    open: boolean = true;
    maxWidth: string = "600px";
    maxHeight: string = "645px";

    constructor(private changeDetectorRef: ChangeDetectorRef,
                private modalsService: FUIModalsService) {
    }

    setup(sellableId: number, sellableName: string, outletGroupId: number, countdowns: { [sellableId: string]: ProductCountDownData }): void {
        this.sellableId = sellableId;
        this.sellableName = sellableName;
        this.outletGroupId = outletGroupId;
        this.countdowns = countdowns;

        this.changeDetectorRef.detectChanges();
    }

    cancel(): void {
        this.onClose.emit(false);
        this.modalsService.close(this);
    }

    ok(): void {
        this.onClose.emit(true);
        this.modalsService.close(this);
    }
}
